import {
  GetInitialConfigurationLoginDetail,
  GetInitialConfigurationOutput,
  LinkDtoOutput,
} from '../mycicero-web-api/shared/get-initial-configuration-output.model'
import { InitialConfigState } from './store/reducers/initial-config.reducer'
import { ExternalProviderEnum } from '../../login/external-provider/external-provider.enum'
import { LoginMethodEnum } from '../../login/shared/login-method-enum'
import { DomSanitizer } from '@angular/platform-browser'
import { SecurityContext } from '@angular/core'
import {
  ExternalClientLinks,
  externalLinkCodes,
  externalLinksCodesToShowInLoginForm,
} from './external-link-codes.constants'

export const ExternalLoginDetailMapper = (data: GetInitialConfigurationLoginDetail): ExternalProviderEnum => {
  return data.Provider.toLowerCase() as ExternalProviderEnum
}

export const InternalLoginDetailMapper = (data: GetInitialConfigurationLoginDetail): LoginMethodEnum => {
  return data.Provider.toLowerCase() as LoginMethodEnum
}

export const externalTermsLinksMapper = (data: LinkDtoOutput[]): string[] =>
  data
    .filter((d) => externalLinksCodesToShowInLoginForm.includes(d.Code))
    .sort((d1, d2) => d1.Order - d2.Order)
    .map(
      (link) => `<a href="${link.Url}" rel="noopener noreferrer" target="_blank">${ExternalClientLinks[link.Code]}</a>`,
    )

export const externalInfoPageLinkMapper = (data: LinkDtoOutput[]): string | null => {
  const urlToMap = data.find((d) => d.Code === externalLinkCodes.INFO)
  if (!urlToMap) {
    return null
  }
  return `<a href="${urlToMap.Url}" target="_blank" rel="noopener noreferrer">${ExternalClientLinks[urlToMap.Code]}</a>`
}

export const GetInitialConfigurationMapper = (
  data: GetInitialConfigurationOutput,
  sanitizer: DomSanitizer,
): InitialConfigState => {
  return {
    loaded: true,
    config: {
      useTestRecaptcha: !data.UseRecaptcha,
      externalAuthProviders: data.AuthenticationMethods.ExternalLogins.sort((m1, m2) => m1.Order - m2.Order).map(
        ExternalLoginDetailMapper,
      ),
      internalAuthMethods: data.AuthenticationMethods.InternalLogins.sort((m1, m2) => m1.Order - m2.Order).map(
        InternalLoginDetailMapper,
      ),
      externalClientDetails: data.AuthorizeClientInformation
        ? {
            externalClientName: data.AuthorizeClientInformation.AuthorizeClientName,
            externalTermsPrivacyLinks: externalTermsLinksMapper(data.AuthorizeClientInformation.Links).map((link) =>
              sanitizer.sanitize(SecurityContext.HTML, link),
            ),
            externalInfoPage: sanitizer.sanitize(
              SecurityContext.HTML,
              externalInfoPageLinkMapper(data.AuthorizeClientInformation.Links),
            ),
          }
        : { externalClientName: null, externalTermsPrivacyLinks: [], externalInfoPage: null },
    },
  }
}
